/**
 * The small plus the design draws wherever two of its rules meet.
 *
 * Shared, because it appears in two unrelated places: the rail grid measures
 * where section boundaries cross the page's rails, and a panel that sits on
 * top of the page draws them at its own corners to read as part of the same
 * drawing. One definition means the two cannot drift apart in size or weight.
 *
 * It centres on its own position, so a caller places the point it should sit
 * on rather than a box it should fill.
 */
export function Cross({ className, style }: { className?: string; style?: React.CSSProperties }) {
    return (
        <span
            aria-hidden="true"
            className={`pointer-events-none absolute block h-[11px] w-[11px] -translate-x-1/2 -translate-y-1/2 ${className ?? ''}`}
            style={style}
        >
            <span className="absolute top-0 left-[5px] block h-[11px] w-px bg-[rgba(239,237,232,0.42)]" />
            <span className="absolute top-[5px] left-0 block h-px w-[11px] bg-[rgba(239,237,232,0.42)]" />
        </span>
    )
}
